var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("picture", [
    _vm.imageConversionEnabled
      ? _c("source", {
          attrs: { srcset: _vm.imgUrl + ".avif", type: "image/avif" },
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.imageConversionEnabled
      ? _c("source", {
          attrs: { srcset: _vm.imgUrl + ".webp", type: "image/webp" },
        })
      : _vm._e(),
    _vm._v(" "),
    _c(
      "img",
      _vm._b(
        {
          class: _vm.imgClass,
          attrs: { src: _vm.imgUrl, alt: _vm.alt, title: _vm.title },
          on: {
            load: function (e) {
              return _vm.$emit("load", e)
            },
          },
        },
        "img",
        _vm.additionalProps,
        false
      )
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }